import { Component } from "react";
import Table from '@mui/material/Table';
import { Button, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";

export default class BookingTable extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {rows: [
            {bookingDay: 'heute', buildingName: 'Building Gebäude B - Hannover', zoneName: 'EG Notd Neu Neuer', deskName: 'Desk X', bookingState: 'PENDING'},
            {bookingDay: 'gestern', buildingName: 'Building 2 - Gebäude A Hannover', zoneName: 'EG Nord', deskName: 'Desk y - EG Nord Neu', bookingState: 'BOOKED'}
        ]}

        fetch('bookings')
        .then(result => result.json())
        .then(r => {Array.isArray(r) &&
            this.setState({rows: r})
        })
        .catch(e => console.error(e));
    }



    render() {
        return(
        <TableContainer sx={{borderRadius: 2, border: 1}}>
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell sx={{fontSize: 23}}>Tag</TableCell>
                    <TableCell sx={{fontSize: 23}}>Gebäude</TableCell>
                    <TableCell sx={{fontSize: 23}}>Zone</TableCell>
                    <TableCell sx={{fontSize: 23}}>Sitzplatz</TableCell>
                    <TableCell sx={{fontSize: 23}}>Status</TableCell>
                    <TableCell/>
                </TableRow>
            </TableHead>
            <TableBody>
                {this.state.rows.map((row) =>
                    <TableRow key={row.id}>
                        <TableCell>{row.bookingDay}</TableCell>
                        <TableCell>{row.buildingName}</TableCell>
                        <TableCell>{row.zoneName}</TableCell>
                        <TableCell>{row.deskName}</TableCell>
                        <TableCell>{row.bookingState}</TableCell>
                        <TableCell>{row.bookingState === 'PENDING' && <Button className="noMarginY">stornieren</Button>}</TableCell>
                    </TableRow>
                )}
            </TableBody>
        </Table>
        </TableContainer>)
    }
}